const Selectize = require('@selectize/selectize/dist/js/selectize.js');

export default {

	init() {
		this.bindEvents();
	},

	bindEvents() {

		// Custom selects
		$('select').not('[data-select-native]').selectize({
			setFirstOptionActive: false,
			deselectBehavior: 'top',
			onInitialize: function() {
				this.$control_input.attr('readonly', true);

				// flag active filter
				let isActive = this.getValue() !== '';
				this.$input.attr('data-js-active', isActive);
				this.$control.toggleClass('is-active', isActive);
			},
			onDropdownOpen: function() {
				let $selectized = $('.selectized').not(this.$input);

				// force any other open dropdowns closed
				$selectized.each(function() {
					let $select = this.selectize;
					$select.blur();
				});
			},
			onChange: function() {
				let group = this.$input.attr('data-js-group');
				let $selectized = $('.selectized[data-js-group='+group+']').not(this.$input);

				if(group !== 'filter') {
					return;
				}

				// flag active filter
				let isActive = this.getValue() !== '' && this.isFocused;
				this.$input.attr('data-js-active', isActive);
				this.$control.toggleClass('is-active', isActive);

				// reset any other filters
				$selectized.each(function() {
					let $select = this.selectize;
					if($select.isFocused === false) {
						$select.setValue('');
					}
				});
			}
		});

		// Filter event listeners
		$('#content').on('submit', 'form[data-js="filters"]', this.handleFilterSubmit);
		$('#content').on('change', 'form[data-js="filters"] select', this.handleFilterChange);
		$('#content').on('click', 'form[data-js="filters"] [data-js="reset"]', this.handleFilterReset);

		// Load more listener
		$('#content').on('click', '[data-js="loadmore"]', this.handleLoadMore);
	},

	handleFilterChange(e) {
		if($(this).attr('data-js-active') === 'true') {
			$(this).parents('form[data-js="filters"]').trigger('submit');
		}
	},

	handleFilterSubmit(e) {
		e.preventDefault();

		let $form = $(this);
		let $container = $('#results');
		let $masthead = $('#masthead');
		let $clients = $('#clients');
		let $related = $('#related');
		let formAction = $form.attr('action');
		let url;

		if($form.attr('action').includes('/styleguide/')) {
			url = $form.attr('action') + '?' + $form.serialize();
		} else {
			let filterSlug = '';
			$.each($form.serializeArray(), function(index, filter){
				if(filter.value) {
					filterSlug = filter.value;
				}
			});
			// activeFilter
			url = filterSlug ? $form.attr('action') + filterSlug + '/' : $form.attr('action');
		}

		$('body').addClass('is-filtered');

		$.get(url, function(data) {
			let $data = $(data);
			let $isFiltered = $data.find('form[data-js="filters"]').hasClass('is-filtered');

			$form.toggleClass('is-filtered', $isFiltered);

			console.log($data.find('#results'));

			$data.find('#masthead')[0].style.setProperty('--animation-delay', '0s');
			$masthead.replaceWith($data.find('#masthead'));
			$container.replaceWith($data.find('#results'));

			if($data.find('#clients').length) {
				$clients.replaceWith($data.find('#clients'));
			}

			if($data.find('#related').length) {
				$related.replaceWith($data.find('#related'));
			}

			// Rebind events for new content
			Filters.rebindEvents();

			// Update URL
			Filters.updateUrl(url);

			// Update Loadmore button
			$('#pager').replaceWith($data.find('#pager'));
		});

	},

	handleFilterReset(e) {
		e.preventDefault();
		let $form = $(this).parents('form[data-js="filters"]');
		let $filters = $form.find('select');

		$filters.each(function() {
			if(this.selectize) {
				this.selectize.setValue('');
			} else {
				$(this).attr('data-js-active', false);
				this.value = '';
			}
		});

		$form.trigger('submit');

		$('body').removeClass('is-filtered');
	},

	handleLoadMore(e) {
		e.preventDefault();

		let $button = $(this);
		let $container = $('#results');
		let url = $button.attr('href');
		let loadedUrl = $button.attr('data-loaded-url');

		$button.text('Loading...').addClass('disabled').on('click', function() { return false; });

		$.get(url, function(data) {
			let $data = $(data);

			$container.append($data.find('#results').contents());
			$container.next('#pager').replaceWith($data.find('#pager'));

			// Update browser url history
			Filters.updateUrl(loadedUrl);

			// Rebind events for new content
			Filters.rebindEvents();
		});

	},

	rebindEvents() {
		Collapse.bindEvents();
		Sliders.bindEvents();
		Video.bindEvents();
	},

	updateUrl(url) {
		if(window.history.pushState) {
			window.history.pushState({}, '', url);
		}
	},

};